const splitArrayIntoChunks = <T>(array: T[], chunkSize: number = 4, collapse: boolean = false): (T | null)[][] => {
  const result: (T | null)[][] = [];

  for (let i = 0; i < Math.ceil(array.length / chunkSize); i++) {
    const chunk: (T | null)[] = array.slice(i * chunkSize, (i + 1) * chunkSize);

    if (!collapse || array.length > chunkSize) {
      while (chunk.length < chunkSize) {
        chunk.push(null);
      }
    }

    result.push(chunk);
  }

  return result;
};

/**
 * Teilt ein Array in kleinere Arrays (Chunks) einer bestimmten Größe auf.
 * @param array - Das zu teilende Array
 * @param chunkSize - Die gewünschte Größe der Teilarrays (Standard: 4)
 * @returns Ein Array von Teilarrays
 */
export const splitIntoChunks = <T>(array: T[], chunkSize = 4): T[][] => {
  const chunksCount = Math.ceil(array.length / chunkSize);

  return Array.from({length: chunksCount}, (_, index) => array.slice(index * chunkSize, (index + 1) * chunkSize));
};

export const fillArrayToSize = <T>(chunk: T[], targetSize: number): (T | null)[] => {
  const fillCount = targetSize - chunk.length;
  const nullFillers = Array(fillCount).fill(null);
  return [...chunk, ...nullFillers];
};

export const splitIntoEqualChunks = <T>(array: T[], chunkSize = 4): (T | null)[][] => {
  return splitIntoChunks(array, chunkSize).map(chunk =>
    chunk.length < chunkSize ? fillArrayToSize(chunk, chunkSize) : chunk
  );
};

export default splitArrayIntoChunks;
